"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name")),
    _AddonListItems = _interopRequireDefault(require("./AddonListItems")),
    _CaptionListItems = _interopRequireDefault(require("./CaptionListItems")),
    _TotalSummary = _interopRequireDefault(require("./TotalSummary"));

require("../styles/_addons-invoice.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function getCaptionsByType(addons, getCaptions) {
  var captions = getCaptions(addons);
  return captions.reduce(function (captionsByType, caption) {
    if (!caption.type) return captionsByType;
    var currentCaptions = captionsByType[caption.type] || [];
    return _objectSpread({}, captionsByType, (0, _defineProperty2["default"])({}, caption.type, [].concat((0, _toConsumableArray2["default"])(currentCaptions), [caption])));
  }, {});
}

function AddonsInvoice(_ref) {
  var onModifyAddons = _ref.onModifyAddons,
      videoOutputs = _ref.videoOutputs,
      addonsSelector = _ref.addonsSelector,
      videoName = _ref.videoName,
      excludeAdditionalOutputCost = _ref.excludeAdditionalOutputCost,
      getCaptions = _ref.getCaptions,
      totalCost = _ref.totalCost,
      getCurrencySymbol = _ref.getCurrencySymbol,
      getFormattedAddon = _ref.getFormattedAddon;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "addons__title"
  }, "Order Items"), _react["default"].createElement("div", {
    className: "addons__body"
  }, _react["default"].createElement("div", {
    className: "addons__body__list"
  }, videoOutputs.map(function (videoOutput, index) {
    var isMaster = videoOutput.isMaster,
        selectedAddons = isMaster || excludeAdditionalOutputCost ? videoOutput.versions[0][addonsSelector] : _objectSpread({
      VIDEO_OUTPUT: {
        value: "ADDITIONAL_OUTPUT"
      }
    }, videoOutput.versions[0][addonsSelector]),
        captionsByType = getCaptionsByType(selectedAddons, getCaptions),
        videoOutputName = (0, _getVideoOutputName["default"])(videoOutput, videoName);
    return _react["default"].createElement(_react.Fragment, {
      key: videoOutputName
    }, _react["default"].createElement("div", {
      className: "addons__body__video-output"
    }, videoOutputName), _react["default"].createElement("div", {
      className: "addons__body__list-items"
    }, _react["default"].createElement(_AddonListItems["default"], {
      addons: selectedAddons,
      getFormattedAddon: getFormattedAddon
    }), captionsByType.SRT ? _react["default"].createElement(_CaptionListItems["default"], {
      captions: captionsByType.SRT,
      type: "SRT"
    }) : null, captionsByType["BURN-IN"] ? _react["default"].createElement(_CaptionListItems["default"], {
      captions: captionsByType["BURN-IN"],
      type: "BURN-IN"
    }) : null), index === videoOutputs.length - 1 ? null : _react["default"].createElement("hr", {
      className: "addons__body__video-output__horizontal-line"
    }));
  })), _react["default"].createElement(_TotalSummary["default"], {
    total: totalCost,
    currencySymbol: getCurrencySymbol(),
    onModifyAddons: onModifyAddons
  })));
}

var _default = (0, _react.memo)(AddonsInvoice);

exports["default"] = _default;